// extracted by mini-css-extract-plugin
export default {"modalBackdrop":"SliderModal_modalBackdrop__IKRh+","sidebar":"SliderModal_sidebar__ysQWg","sidebarHolder":"SliderModal_sidebarHolder__2b2Y6"};